"use strict";

import Swiper from 'swiper';
import { Scrollbar } from 'swiper/modules';

document.addEventListener("DOMContentLoaded", () => {
    initEventsSummary();
});

const initEventsSummary = () => {
    document.querySelectorAll('.events-summary').forEach(container => {
        initSingleSummary(container);
    });
};

const initSingleSummary = (container) => {
    const monthEl = container.querySelector('.current-month');
    const prevBtn = container.querySelector('.prev-month');
    const nextBtn = container.querySelector('.next-month');
    const daysWrapper = container.querySelector('.swiper-wrapper');
    const summaryEl = container.querySelector('.summary');
    const selectedDayEl = container.querySelector('.selected-day span');
    const scrollbarEl = container.querySelector('.swiper-scrollbar');
    const moreWrap = container.querySelector('.more');

    const lang = scriptObj.lang === 'en' ? 'en' : 'pl';

    const MONTHS = {
        pl: ['styczeń','luty','marzec','kwiecień','maj','czerwiec','lipiec','sierpień','wrzesień','październik','listopad','grudzień'],
        en: ['January','February','March','April','May','June','July','August','September','October','November','December']
    };

    const MONTHS_GEN = {
        pl: ['stycznia','lutego','marca','kwietnia','maja','czerwca','lipca','sierpnia','września','października','listopada','grudnia'],
        en: ['January','February','March','April','May','June','July','August','September','October','November','December']
    };

    const WEEKDAYS = {
        pl: ['Niedziela','Poniedziałek','Wtorek','Środa','Czwartek','Piątek','Sobota'],
        en: ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday']
    };

    const WEEKDAYS_SHORT = {
        pl: ['Nd','Po','Wt','Śr','Cz','Pi','So'],
        en: ['Su','Mo','Tu','We','Th','Fr','Sa']
    };

    const EMPTY_TEXT = {
        pl: 'Brak wydarzeń w tym dniu',
        en: 'No events on this day'
    };

    const today = new Date();
    const baseYear = today.getFullYear();
    const baseMonth = today.getMonth();

    let currentYear = baseYear;
    let currentMonth = baseMonth;
    let swiper = null;
    let selectedDay = null;

    const ymd = (y,m,d) =>
        y + String(m + 1).padStart(2,'0') + String(d).padStart(2,'0');

    const renderMonthLabel = () => {
        monthEl.textContent = `${MONTHS[lang][currentMonth]} ${currentYear}`;
    };

    const togglePrev = () => {
        prevBtn.classList.remove('hidden');
    };

    const renderDays = () => {
        daysWrapper.innerHTML = '';
        const daysInMonth = new Date(currentYear, currentMonth + 1, 0).getDate();

        for (let d = 1; d <= daysInMonth; d++) {
            const date = new Date(currentYear, currentMonth, d);
            const dateStr = ymd(currentYear, currentMonth, d);

            const classes = ['day'];

            if (
                date.getFullYear() === today.getFullYear() &&
                date.getMonth() === today.getMonth() &&
                date.getDate() === today.getDate()
            ) {
                classes.push('today');
            }

            const slide = document.createElement('div');
            slide.className = 'swiper-slide';
            slide.innerHTML = `
                <div class="${classes.join(' ')}" data-date="${dateStr}">
                    <span>${WEEKDAYS_SHORT[lang][date.getDay()]}</span>
                    <span><i>${d}</i></span>
                </div>
            `;

            daysWrapper.appendChild(slide);
        }

        initSwiper();
        loadDaysAjax();
    };

    const initSwiper = () => {
        if (swiper) swiper.destroy(true, true);

        swiper = new Swiper(container.querySelector('.slider-choose-day'), {
            modules: [Scrollbar],
            slidesPerView: 'auto',
            spaceBetween: 8,
            speed: 600,
            scrollbar: {
                el: scrollbarEl,
                draggable: true,
            }
        });
    };

    const slideToToday = () => {
        if (
            currentYear === baseYear &&
            currentMonth === baseMonth &&
            swiper
        ) {
            const todayEl = container.querySelector('.day.today');
            if (todayEl) {
                const slideEl = todayEl.closest('.swiper-slide');
                const index = [...daysWrapper.children].indexOf(slideEl);
                if (index >= 0) {
                    swiper.slideTo(index, 0);
                }
            }
        }
    };

    const loadDaysAjax = () => {
        const formData = new FormData();
        formData.append('action', 'load_moredays_action');
        formData.append('_wpnonce', scriptObj.nonce);
        formData.append('year', currentYear);
        formData.append('month', currentMonth + 1);
        formData.append('lang', scriptObj.lang);

        fetch(scriptObj.ajaxurl, {
            method: 'POST',
            body: formData
        })
            .then(res => res.json())
            .then(data => {
                if (data.days && Array.isArray(data.days)) {
                    const todayStr = ymd(today.getFullYear(), today.getMonth(), today.getDate());

                    data.days.forEach(dateStr => {
                        const el = container.querySelector(`.day[data-date="${dateStr}"]`);
                        if (!el) return;

                        el.classList.add('active');
                        el.classList.toggle('pass', dateStr < todayStr);
                    });
                }

                slideToToday();

                // FIX : w bieżącym miesiącu klikaj dzisiejszy dzień,
                // w poprzednich miesiącach klikaj pierwszy dzień z wydarzeniem,
                // a jeśli nie ma żadnego — pierwszy dzień miesiąca
                if (!selectedDay) {
                    if (currentYear === baseYear && currentMonth === baseMonth) {
                        const todayEl = container.querySelector('.day.today');
                        if (todayEl) todayEl.click();
                    } else {
                        const firstActiveEl = container.querySelector('.day.active');
                        const fallbackEl = container.querySelector('.day');
                        (firstActiveEl || fallbackEl)?.click();
                    }
                }
            });
    };

    const clearSummary = () => {
        summaryEl.innerHTML = '';
        moreWrap.classList.add('hidden');
    };

    const showEmpty = () => {
        clearSummary();
        const div = document.createElement('div');
        div.className = 'empty-message';
        div.textContent = EMPTY_TEXT[lang];
        summaryEl.appendChild(div);
    };

    const updateSelectedLabel = (date) => {
        selectedDayEl.textContent =
            lang === 'en'
                ? `${WEEKDAYS.en[date.getDay()]}, ${MONTHS_GEN.en[date.getMonth()]} ${date.getDate()}, ${date.getFullYear()}`
                : `${WEEKDAYS.pl[date.getDay()]}, ${date.getDate()} ${MONTHS_GEN.pl[date.getMonth()]} ${date.getFullYear()}`;
    };

    const loadEventsForDay = (date) => {
        const moreBtn = container.querySelector('.btn--more');
        let page = 1;

        const load = (append = false) => {
            const formData = new FormData();
            formData.append('action', 'load_moreevents');
            formData.append('_wpnonce', scriptObj.nonce);
            formData.append('date', date);
            formData.append('pp', page);
            formData.append('lang', scriptObj.lang);

            fetch(scriptObj.ajaxurl, {
                method: 'POST',
                body: formData
            })
                .then(res => res.json())
                .then(data => {
                    if (!append) summaryEl.innerHTML = '';
                    if (data.data) summaryEl.insertAdjacentHTML('beforeend', data.data);
                    if (data.max > page) moreWrap.classList.remove('hidden');
                    else moreWrap.classList.add('hidden');
                });
        };

        load();

        moreBtn.onclick = (e) => {
            e.preventDefault();
            page++;
            load(true);
        };
    };

    const handleDayClick = (dayEl) => {
        container.querySelectorAll('.day.choosen').forEach(d => d.classList.remove('choosen'));
        dayEl.classList.add('choosen');
        selectedDay = dayEl.dataset.date;

        const y = Number(selectedDay.slice(0,4));
        const m = Number(selectedDay.slice(4,6)) - 1;
        const d = Number(selectedDay.slice(6,8));

        updateSelectedLabel(new Date(y,m,d));

        if (!dayEl.classList.contains('active')) {
            showEmpty();
            return;
        }

        clearSummary();
        loadEventsForDay(selectedDay);
    };

    container.addEventListener('click', e => {
        const day = e.target.closest('.day');
        if (!day || !container.contains(day)) return;
        handleDayClick(day);
    });

    prevBtn.addEventListener('click', () => {
        currentMonth--;
        if (currentMonth < 0) {
            currentMonth = 11;
            currentYear--;
        }
        // Reset selectedDay przy zmianie miesiąca, żeby FIX zadziałał
        selectedDay = null;
        renderMonthLabel();
        togglePrev();
        renderDays();
    });

    nextBtn.addEventListener('click', () => {
        currentMonth++;
        if (currentMonth > 11) {
            currentMonth = 0;
            currentYear++;
        }
        // Reset selectedDay przy zmianie miesiąca, żeby FIX zadziałał
        selectedDay = null;
        renderMonthLabel();
        togglePrev();
        renderDays();
    });

    renderMonthLabel();
    togglePrev();
    renderDays();
};